import * as React from 'react'
import type { RecipientList } from 'types/list'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
type Props = {
  list: RecipientList | null | undefined
}
export const CAPTION_EXISTING = 'Add from Contacts'
export const CAPTION_IMPORT = 'Import contacts from CSV'
export const CAPTION_SINGLE = 'Add new contact'
export const CAPTION_EXPORT = 'Export Mailing List to CSV'

const ContactsMenuAddButtons = (props: Props): React.ReactNode => {
  const { list } = props
  const addLink = list && `/contacts/list?append=${list.id}`
  const importLink = list
    ? `/lists/${list.id}/file-import`
    : '/contacts/list/file-import'
  const singleLink = list
    ? `/lists/${list.id}/add-single`
    : '/contacts/list/add-single'
  return (
    <ButtonContainer vertical>
      {addLink && (
        <Button
          appearance="primary"
          caption={CAPTION_EXISTING}
          link={addLink}
          fullWidth
        />
      )}
      <Button caption={CAPTION_IMPORT} link={importLink} fullWidth />
      <Button caption={CAPTION_SINGLE} link={singleLink} fullWidth />
    </ButtonContainer>
  )
}

export default ContactsMenuAddButtons
